import type {
    ClientInterface,
    FastLoginRequest,
    LoginRequest,
    SocialLoginConfirmRequest,
    SocialLoginInitRequest,
    SocialLoginInitResponse,
    SuccessResponse,
} from '@/api/auth/interface'

import client from '@/api/client'
import type { Response } from '@/api/response'
import { handleError } from '@/api/response'
import { captchaHeaders } from '@/plugins/captcha'

class Client implements ClientInterface {
    login(request: LoginRequest): Promise<Response<SuccessResponse>> {
        return new Promise<Response<SuccessResponse>>((resolve, reject) => {
            client
                .post<SuccessResponse>(
                    '/api/v1/auth/login',
                    {
                        email: request.email,
                        password: request.password,
                        remember_me: request.rememberMe,
                    },
                    {
                        headers: captchaHeaders(request.captcha),
                    }
                )
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (err) {
                    handleError(err, resolve, reject);
                });
        });
    }

    fastLogin(request: FastLoginRequest): Promise<Response<SuccessResponse>> {
        return new Promise<Response<SuccessResponse>>((resolve, reject) => {
            client
                .post<SuccessResponse>(
                    '/api/v1/auth/fast-login',
                    {
                        token: request.token,
                    }
                )
                .then(function (response) {
                    resolve({
                        data: response.data,
                    });
                })
                .catch(function (err) {
                    handleError(err, resolve, reject);
                });
        });
    }

    logout(): Promise<Response<SuccessResponse>> {
        return new Promise<Response<SuccessResponse>>((resolve, reject) => {
            client
                .post<SuccessResponse>('/api/v1/auth/logout', {})
                .then(function (response) {
                    resolve({
                        data: response.data,
                    });
                })
                .catch(function (err) {
                    handleError(err, resolve, reject);
                });
        });
    }

    initSocialLogin(request: SocialLoginInitRequest): Promise<Response<SocialLoginInitResponse>> {
        return new Promise<Response<SocialLoginInitResponse>>((resolve, reject) => {
            client
                .post<SocialLoginInitResponse>(`/api/v1/auth/social/${request.provider}/connection`, {})
                .then(function (response) {
                    resolve({
                        data: response.data,
                    })
                })
                .catch(function (err) {
                    handleError(err, resolve, reject);
                })
        })
    }

    confirmSocialLogin(request: SocialLoginConfirmRequest): Promise<Response<SuccessResponse>> {
        return new Promise<Response<SuccessResponse>>((resolve, reject) => {
            client
                .post<SuccessResponse>(`/api/v1/auth/social/${request.provider}/confirmation`, {
                    code: request.code,
                    state: request.state,
                })
                .then(function (response) {
                    resolve({
                        data: response.data,
                    })
                })
                .catch(function (err) {
                    handleError(err, resolve, reject);
                })
        })
    }
}

export default new Client();
